/* ------------------------------------------------------------------
   APEX AFFAIR — Produktseiten-Feinschliff  (Stand 08.09.2026)
   Wird aus layout/theme.liquid geladen. Entfernen = die eine
   <script>-Zeile dort loeschen.

   1. Versand-Reiter: "ab 3 Teilen" -> echte Regel (100 EUR Bestellwert)
   2. Lieferdatum ueber Menge + Kaufbutton (Menge und Button in einer Zeile)
   3. Zahlungslogos unter die Merkmale
   4. Vier Produktmerkmale (je Produktart) unter den Button
      (unter PayPal/Apple Pay, falls Sofort-Kaufen aktiv, Stand 28.09.2026)
------------------------------------------------------------------ */
(function () {
  'use strict';

  if (!/\/products\//.test(window.location.pathname)) return;

  var MONTHS = ['Januar','Februar','März','April','Mai','Juni','Juli',
                'August','September','Oktober','November','Dezember'];
  var DAYS   = ['So','Mo','Di','Mi','Do','Fr','Sa'];

  /* ---------- Sprachen (28.09.2026) ----------
     Sprache kommt aus <html lang>, also aus der Shop-URL (/fr, /it ...).
     Fehlt eine Sprache, gilt Deutsch. */
  var LANG = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  /* Merkmale je Produktart (28.09.2026, nach Kundenfragen: Stoff, Print, Herkunft,
     Rueckgabe). Passform-Hinweis steht jetzt als eigener Block unter Groesse/Farbe
     (blocks/apex-pdp-note.liquid). */
  var I18N = {
    de: {
      months: MONTHS, days: DAYS, dayFmt: 'de',
      eta: 'Lieferung voraussichtlich ',
      usp: {
        shirt: ['Schwerer Stoff: 200 g/m², 100 % Baumwolle', 'Großer Print auf dem Rücken',
                'Designt und gedruckt in Deutschland', '14 Tage Rückgabe, auch auf reduzierte Artikel'],
        hoodie: ['Schwerer Stoff: 380 g/m², 70 % Baumwolle, 30 % Polyester', 'Innen angeraut, großer Print auf dem Rücken',
                 'Designt und gedruckt in Deutschland', '14 Tage Rückgabe, auch auf reduzierte Artikel'],
        other: ['Designt und gedruckt in Deutschland', '14 Tage Rückgabe, auch auf reduzierte Artikel']
      }
    },
    fr: {
      months: ['janvier','février','mars','avril','mai','juin','juillet',
               'août','septembre','octobre','novembre','décembre'],
      days: ['dim.','lun.','mar.','mer.','jeu.','ven.','sam.'], dayFmt: 'fr',
      eta: 'Livraison prévue ',
      usp: {
        shirt: ['Tissu épais : 200 g/m², 100 % coton', 'Grand print dans le dos',
                'Conçu et imprimé en Allemagne', 'Retours sous 14 jours, même sur les articles en promo'],
        hoodie: ['Tissu épais : 380 g/m², 70 % coton, 30 % polyester', 'Intérieur gratté, grand print dans le dos',
                 'Conçu et imprimé en Allemagne', 'Retours sous 14 jours, même sur les articles en promo'],
        other: ['Conçu et imprimé en Allemagne', 'Retours sous 14 jours, même sur les articles en promo']
      }
    },
    it: {
      months: ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio',
               'agosto','settembre','ottobre','novembre','dicembre'],
      days: ['dom','lun','mar','mer','gio','ven','sab'], dayFmt: 'it',
      eta: 'Consegna prevista ',
      usp: {
        shirt: ['Tessuto pesante: 200 g/m², 100% cotone', 'Grande stampa sulla schiena',
                'Disegnato e stampato in Germania', 'Reso entro 14 giorni, anche sugli articoli scontati'],
        hoodie: ['Tessuto pesante: 380 g/m², 70% cotone, 30% poliestere', 'Interno felpato, grande stampa sulla schiena',
                 'Disegnato e stampato in Germania', 'Reso entro 14 giorni, anche sugli articoli scontati'],
        other: ['Disegnato e stampato in Germania', 'Reso entro 14 giorni, anche sugli articoli scontati']
      }
    },
    es: {
      months: ['enero','febrero','marzo','abril','mayo','junio','julio',
               'agosto','septiembre','octubre','noviembre','diciembre'],
      days: ['dom','lun','mar','mié','jue','vie','sáb'], dayFmt: 'es',
      eta: 'Entrega prevista ',
      usp: {
        shirt: ['Tejido grueso: 200 g/m², 100 % algodón', 'Estampado grande en la espalda',
                'Diseñado e impreso en Alemania', 'Devolución en 14 días, también en artículos rebajados'],
        hoodie: ['Tejido grueso: 380 g/m², 70 % algodón, 30 % poliéster', 'Interior perchado, estampado grande en la espalda',
                 'Diseñado e impreso en Alemania', 'Devolución en 14 días, también en artículos rebajados'],
        other: ['Diseñado e impreso en Alemania', 'Devolución en 14 días, también en artículos rebajados']
      }
    },
    en: {
      months: ['January','February','March','April','May','June','July',
               'August','September','October','November','December'],
      days: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], dayFmt: 'en',
      eta: 'Estimated delivery ',
      usp: {
        shirt: ['Heavy fabric: 200 gsm, 100% cotton', 'Big print on the back',
                'Designed and printed in Germany', '14-day returns, sale items included'],
        hoodie: ['Heavy fabric: 380 gsm, 70% cotton, 30% polyester', 'Brushed inside, big print on the back',
                 'Designed and printed in Germany', '14-day returns, sale items included'],
        other: ['Designed and printed in Germany', '14-day returns, sale items included']
      }
    },
    nl: {
      months: ['januari','februari','maart','april','mei','juni','juli',
               'augustus','september','oktober','november','december'],
      days: ['zo','ma','di','wo','do','vr','za'], dayFmt: 'nl',
      eta: 'Verwachte levering ',
      usp: {
        shirt: ['Zware stof: 200 g/m², 100% katoen', 'Grote print op de rug',
                'Ontworpen en bedrukt in Duitsland', '14 dagen retour, ook op afgeprijsde artikelen'],
        hoodie: ['Zware stof: 380 g/m², 70% katoen, 30% polyester', 'Geruwde binnenkant, grote print op de rug',
                 'Ontworpen en bedrukt in Duitsland', '14 dagen retour, ook op afgeprijsde artikelen'],
        other: ['Ontworpen en bedrukt in Duitsland', '14 dagen retour, ook op afgeprijsde artikelen']
      }
    }
  };
  /* Produktart aus der Adresse (Handles enden auf -hoodie / -shirt). */
  var PATH = window.location.pathname.toLowerCase();
  var KIND = /hoodie/.test(PATH) ? 'hoodie' : (/shirt|tee/.test(PATH) ? 'shirt' : 'other');
  var T = I18N[LANG] || I18N.de;

  /* ---------- 1. Versand-Reiter richtigstellen ---------- */
  var SHIP_FIXES = [
    [/ab\s*3\s*Teilen\s*versandkostenfrei/gi, 'ab 100 € Bestellwert versandkostenfrei'],
    [/ab\s*3\s*Teilen\s*(\d+,\d{2})\s*€/gi, 'ab 100 € Bestellwert nur $1 €'],
    [/ab\s*3\s*Produkten/gi, 'ab 100 € Bestellwert']
  ];

  function fixShippingText() {
    var nodes = document.querySelectorAll('[class*="ss-tabs"] p, [class*="ss-tabs"] li, [class*="tab"] p');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length && !/ab\s*3\s*(Teilen|Produkten)/i.test(el.textContent)) continue;
      var html = el.innerHTML;
      var next = html;
      for (var f = 0; f < SHIP_FIXES.length; f++) next = next.replace(SHIP_FIXES[f][0], SHIP_FIXES[f][1]);
      if (next !== html) el.innerHTML = next;
    }
  }

  /* ---------- 2. Lieferdatum ---------- */
  /* Zusage im Shop und in der Versandrichtlinie: Lieferung in 2 bis 4
     Werktagen. Annahmeschluss 14:00 — danach zaehlt der naechste Werktag
     als Start. Samstag und Sonntag sind keine Werktage. */
  function addWorkdays(from, days) {
    var d = new Date(from);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    return d;
  }

  function deliveryRange() {
    var now = new Date();
    var start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (now.getHours() >= 14) start.setDate(start.getDate() + 1);
    /* Der Startpunkt selbst muss ein Werktag sein. */
    while (start.getDay() === 0 || start.getDay() === 6) {
      start.setDate(start.getDate() + 1);
    }
    return { a: addWorkdays(start, 2), b: addWorkdays(start, 4) };
  }

  function fmt(d, withMonth) {
    if (T.dayFmt === 'de') {
      return T.days[d.getDay()] + '., ' + d.getDate() + '.' +
             (withMonth ? ' ' + T.months[d.getMonth()] : '');
    }
    return T.days[d.getDay()] + ' ' + d.getDate() +
           (withMonth ? ' ' + T.months[d.getMonth()] : '');
  }

  /* ---------- Hilfsfunktionen ---------- */
  function buyBlock() {
    var btn = document.querySelector('.add-to-cart-button:not(.sticky-add-to-cart__button)');
    if (!btn) return null;
    return btn.closest('add-to-cart-component') || btn.closest('form') || btn.parentElement;
  }

  function css() {
    if (document.getElementById('apex-pdp-css')) return;
    var s = document.createElement('style');
    s.id = 'apex-pdp-css';
    s.textContent =
      '.apex-eta{display:flex;align-items:center;gap:8px;margin:0 0 12px;' +
        'font-family:"Inter Tight","Helvetica Neue",Arial,sans-serif;font-size:13px;' +
        'font-weight:600;letter-spacing:.2px;color:#0a0a0a}' +
      '.apex-eta svg{flex-shrink:0}' +
      '.apex-eta span{opacity:.75;font-weight:500}' +
      '.apex-usp{list-style:none;margin:14px 0 0;padding:0;' +
        'font-family:"Inter Tight","Helvetica Neue",Arial,sans-serif;font-size:13.5px;color:#0a0a0a}' +
      '.apex-usp li{display:flex;gap:8px;align-items:flex-start;padding:3px 0}' +
      '.apex-usp li::before{content:"\\2713";font-weight:700;line-height:1.45}' +
      '.apex-fit{margin:12px 0 0;padding:10px 12px;border:1px solid #e0e0e0;' +
        'font-family:"Inter Tight","Helvetica Neue",Arial,sans-serif;font-size:12.5px;' +
        'line-height:1.5;color:#0a0a0a}' +
      '.apex-fit b{font-weight:700}' +
      '.apex-pay-moved{margin-top:10px}' +
      /* Menge und Warenkorb in einer Zeile, PayPal/Apple Pay volle Breite */
      '.product-form-buttons>span:has(add-to-cart-component){flex:1 1 0 !important;min-width:0 !important}' +
      '.product-form-buttons>.accelerated-checkout-block{flex:1 0 100% !important}' +
      '@media (max-width:749px){.product-form-buttons .add-to-cart-button{white-space:nowrap;padding-inline:12px !important}' +
        '.product-form-buttons .add-to-cart-button .add-to-cart-icon{display:none !important}}' +
      '@media (max-width:359px){.product-form-buttons>span:has(add-to-cart-component){flex-basis:100% !important}}';
    document.head.appendChild(s);
  }

  function addEta(block) {
    if (document.querySelector('.apex-eta')) return;
    var r = deliveryRange();
    var el = document.createElement('div');
    el.className = 'apex-eta';
    el.innerHTML =
      '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="1.8" aria-hidden="true"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7z"/>' +
      '<circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
      T.eta + fmt(r.a, false) + ' – ' + fmt(r.b, true);
    /* Ueber die ganze Kaufzeile (Menge + Warenkorb), damit Menge und
       Warenkorb-Button auf gleicher Hoehe stehen (28.09.2026). */
    var row = block.closest('.product-form-buttons');
    var target = row || block;
    target.parentElement.insertBefore(el, target);
  }

  function addUsp(block) {
    if (document.querySelector('.apex-usp')) return;
    var ul = document.createElement('ul');
    ul.className = 'apex-usp';
    ul.innerHTML = (T.usp[KIND] || T.usp.other).map(function (u) { return '<li>' + u + '</li>'; }).join('');
    /* Sofort-Kaufen (PayPal/Apple Pay) bleibt direkt unter dem
       Warenkorb-Button; Merkmale erst danach. */
    var ac = document.querySelector('.accelerated-checkout-block');
    var ref = ac ? (ac.closest('.product-form-buttons') || ac) : block;
    ref.parentElement.insertBefore(ul, ref.nextSibling);

  }

  function movePayIcons(block) {
    var pay = document.querySelector('[class*="sternify"][class*="payment"], [id*="payment_icons"]');
    if (!pay) {
      pay = null;
      var all = document.querySelectorAll('.shopify-block');
      for (var i = 0; i < all.length; i++) {
        if (/payment_icons/.test(all[i].id || '')) { pay = all[i]; break; }
      }
    }
    if (!pay || pay.getAttribute('data-apex-moved')) return;
    pay.setAttribute('data-apex-moved', '1');
    pay.classList.add('apex-pay-moved');
    var anchor = document.querySelector('.apex-usp') || block;
    anchor.parentElement.insertBefore(pay, anchor.nextSibling);
  }

  /* ---------- 1b. Veraltete Lieferzeiten richtigstellen ---------- */
  /* Die Zusage ist 2 bis 4 Werktage (Versandrichtlinie, 11.09.2026).
     An drei Stellen stand noch der alte Wert: im Lagerhinweis der
     Sternify-App und im Versand-Reiter. Beides ist reiner Text und
     laesst sich hier korrigieren; die Datums-Zeitleiste der App rechnet
     dagegen aus eigenen Einstellungen und muss im Customizer geaendert
     werden. */
  var TIME_FIXES = [
    [/in\s*3\s*bis\s*5\s*(Werk)?[Tt]agen/g, 'in 2 bis 4 Werktagen'],
    [/Deutschland\s*3\s*[–—-]\s*5\s*Werktage\s*·\s*übriges\s*Europa\s*5\s*[–—-]\s*9\s*Werktage/g,
     'Deutschland und übriges Europa 2–4 Werktage'],
    [/3\s*[–—-]\s*5\s*Werktage/g, '2–4 Werktage'],
    [/5\s*[–—-]\s*9\s*Werktage/g, '2–4 Werktage']
  ];

  function fixDeliveryTexts() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue;
      if (!v || v.length > 600) continue;
      if (!/3\s*[–—-]?\s*bis|3\s*[–—-]\s*5|5\s*[–—-]\s*9/.test(v)) continue;
      var next = v;
      for (var i = 0; i < TIME_FIXES.length; i++) {
        next = next.replace(TIME_FIXES[i][0], TIME_FIXES[i][1]);
      }
      if (next !== v) node.nodeValue = next;
    }
  }

  function run() {
    if (LANG === 'de') {
      fixShippingText();
      fixDeliveryTexts();
    }
    var block = buyBlock();
    if (!block) return;
    css();
    addEta(block);
    addUsp(block);
    movePayIcons(block);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  /* Der Reiterinhalt wird teils nachgeladen. */
  var ticks = 0;
  var iv = setInterval(function () {
    run();
    if (++ticks > 12) clearInterval(iv);
  }, 900);
})();
